import { asMultiStyleConfig } from '../../utils/theme';
import { getColor } from '../../theme-tools';
var parts = ['button', 'leftIcon', 'rightIcon'];
export var variantPrimary = props => {
  var {
    theme
  } = props;
  return {
    button: {
      _focus: {
        color: props.color,
        borderColor: 'blue.200',
        textDecoration: 'none',
        boxShadow: "0 0 3px 2px ".concat(getColor(theme, 'blue.300')),
        outline: '0'
      },
      _active: {
        '&:after': {
          background: getColor(theme, 'blue.200')
        }
      },
      _hover: {
        outline: '0',
        textDecoration: 'none',
        color: props.color,
        '&:after': {
          background: 'currentColor'
        }
      }
    }
  };
};
var baseStyle = {
  button: {
    color: 'currentColor',
    background: 'none',
    borderRadius: '4px',
    fontWeight: 'bold',
    border: '1px solid transparent',
    px: 3,
    pt: 3,
    pb: 4,
    _after: {
      content: '""',
      display: 'block',
      position: 'absolute',
      bottom: 3,
      left: 3,
      right: 3,
      height: '2px'
    }
  },
  leftIcon: {
    marginRight: 2
  },
  rightIcon: {
    marginLeft: 2
  }
};
var defaultProps = {
  variant: 'primary'
};
export default asMultiStyleConfig({
  parts,
  baseStyle,
  defaultProps,
  variants: {
    primary: variantPrimary
  }
});